module.exports = __webpack_public_path__ + "static/locale-c127bdb711426e3bd90b0ce01bcdec32.png";